var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",on:{"click":function($event){return _vm.showUserInfo($event)}}},[_c('el-avatar',{attrs:{"src":_vm.url,"fit":"fill","alt":"","size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }